import React from "react";
import { Container } from "olive-react-myoneui";
import LearnerProfile from "../../../components/afterLogin/student-dashboard/learners-profile/LearnerProfile";


const StudentProfile = () => {
  return (
    <>
      <div className="dashboard-wrapper myk__stu-dash_outer-wrapper w-100">
        <Container fluid>
          <LearnerProfile />
        </Container>
      </div>
    </>
  );
}

export default StudentProfile;
